import { LoadPanel } from "devextreme-react/load-panel";

export default function ItiLoading() {
	return (
		<LoadPanel
			shadingColor="rgba(0,0,0,0.4)"
			position="center"
			visible={true}
			showIndicator={true}
			shading={true}
			showPane={true}
			delay={200}
		/>
	);
}
